import axios from "axios";

const toEstabelecimentosView = entry => {
  let displayName = entry.nrCodigoOficial + " - " + entry.nmEstabelecimento;
  return { ...entry, displayName };
};

const toRacoesView = entry => {
  let displayName = entry.nmRacao + " - " + entry.cdItem;
  return { ...entry, displayName };
};

const toPlantasAbateView = entry => {
  let displayName = entry.nrRegistroSif + " - " + entry.nmPlantaAbate;
  return { ...entry, displayName };
};

export default {
  actLoadExtensionistas({ commit }) {
    commit("mtChangeLoadingExtensionistas", true);
    axios
      .get("responsavel-tecnico/")
      .then(response => {
        let data =
          response.data[0].data != null
            ? response.data[0].data.map(entry => {
                let displayName = entry.nmPessoa + " - " + entry.nrDocumento;
                return { ...entry, displayName };
              })
            : [];
        commit("mtLoadExtensionistas", data);
      })
      .catch(error => {
        commit("setSnack", { type: "error", msg: error });
      })
      .finally(() => {
        commit("mtChangeLoadingExtensionistas", false);
      });
  },
  actLoadEstabelecimentos({ commit, state }) {
    commit("mtChangeLoadingEstabelecimentos", true);
    axios
      .get(state.urlAPIEstabelecimento + "estabelecimento/")
      .then(response => {
        let data = response.data
          ? response.data.map(toEstabelecimentosView)
          : [];
        commit("mtLoadEstabelecimentos", data);
      })
      .catch(error => {
        commit("setSnack", { type: "error", msg: error });
      })
      .finally(() => {
        commit("mtChangeLoadingEstabelecimentos", false);
      });
  },
  actLoadUFs: ({ commit, state }) => {
    commit("mtChangeLoadingUFs", true);
    axios
      .get(state.urlAPIEstabelecimento + "uf/")
      .then(response => {
        commit("mtLoadUFs", response.data);
      })
      .catch(error => {
        commit("setSnack", { type: "error", msg: error });
      })
      .finally(() => {
        commit("mtChangeLoadingUFs", false);
      });
  },
  actLoadMunicipios: ({ commit, state }) => {
    commit("mtChangeLoadingMunicipios", true);
    axios
      .get(state.urlAPIEstabelecimento + "municipio/")
      .then(response => {
        commit("mtLoadMunicipios", response.data);
      })
      .catch(error => {
        commit("setSnack", { type: "error", msg: error });
      })
      .finally(() => {
        commit("mtChangeLoadingMunicipios", false);
      });
  },
  actLoadMunicipiosByUf: ({ commit, state }, cdUf) => {
    commit("mtChangeLoadingMunicipios", true);
    axios
      .get(
        state.urlAPIEstabelecimento + "municipio/?cdUf=" + cdUf
      )
      .then(response => {
        commit("mtAddMunicipios", response.data);
      })
      .catch(error => {
        commit("setSnack", { type: "error", msg: error });
      })
      .finally(() => {
        commit("mtChangeLoadingMunicipios", false);
      });
  },
  actLoadFabricasRacao({ commit }) {
    commit("mtChangeLoadingFabricasRacao", true);
    axios
      .get("fabrica-racao/")
      .then(response => {
        let data =
          response.data[0].data != null
            ? response.data[0].data.map(entry => {
                var nrSif =
                  entry.nrRegistroSif != null
                    ? entry.nrRegistroSif + " - "
                    : "";
                let displayName = nrSif + entry.nmFabricaRacao;
                return { ...entry, displayName };
              })
            : [];
        commit("mtLoadFabricasRacao", data);
      })
      .catch(error => {
        commit("setSnack", { type: "error", msg: error });
      })
      .finally(() => {
        commit("mtChangeLoadingFabricasRacao", false);
      });
  },
  actLoadStatusPedidoRacao: ({ commit }) => {
    commit("mtChangeLoadingStatusPedidoRacao", true);
    axios
      .get("pedido-racao/lista-tipos/")
      .then(response => {
        commit("mtLoadStatusPedidoRacao", response.data[0].data);
      })
      .catch(error => {
        commit("setSnack", { type: "error", msg: error });
      })
      .finally(() => {
        commit("mtChangeLoadingStatusPedidoRacao", false);
      });
  },
  actLoadRacoes({ commit }) {
    commit("mtChangeLoadingRacoes", true);
    axios
      .get("racao/")
      .then(response => {
        let data = response.data[0].data
          ? response.data[0].data.map(toRacoesView)
          : [];
        commit("mtLoadRacoes", data);
      })
      .catch(error => {
        this.$store.commit("setSnack", { type: "error", msg: error });
      })
      .finally(() => {
        commit("mtChangeLoadingRacoes", false);
      });
  },
  actLoadLaboratorios: ({ commit }) => {
    commit("mtChangeLoadingLaboratorios", true);
    axios
      .get("laboratorio/")
      .then(response => {
        commit("mtLoadLaboratorios", response.data[0].data);
      })
      .catch(error => {
        commit("setSnack", { type: "error", msg: error });
      })
      .finally(() => {
        commit("mtChangeLoadingLaboratorios", false);
      });
  },
  actLoadPrincipiosAtivos: ({ commit }) => {
    commit("mtChangeLoadingPrincipiosAtivos", true);
    axios
      .get("principio-ativo/")
      .then(response => {
        commit("mtLoadPrincipiosAtivos", response.data[0].data);
      })
      .catch(error => {
        commit("setSnack", { type: "error", msg: error });
      })
      .finally(() => {
        commit("mtChangeLoadingPrincipiosAtivos", false);
      });
  },
  actLoadPlantasAbate({ commit }) {
    commit("mtChangeLoadingPlantasAbate", true);
    axios
      .get("planta-abate/")
      .then(response => {
        let data = response.data[0].data
          ? response.data[0].data.map(toPlantasAbateView)
          : [];
        commit("mtLoadPlantasAbate", data);
      })
      .catch(error => {
        commit("setSnack", { type: "error", msg: error });
      })
      .finally(() => {
        commit("mtChangeLoadingPlantasAbate", false);
      });
  },
  actLoadMotivosBaixa: ({ commit }) => {
    commit("mtChangeLoadingMotivosBaixa", true);
    axios
      .get("motivo-baixa/")
      .then(response => {
        commit("mtLoadMotivosBaixa", response.data[0].data);
      })
      .catch(error => {
        commit("setSnack", { type: "error", msg: error });
      })
      .finally(() => {
        commit("mtChangeLoadingMotivosBaixa", false);
      });
  },
  actLoadLotesProducao: ({ commit }) => {
    commit("mtChangeLoadingLotesProducao", true);
    axios
      .get("lote-producao/?per_page=10")
      .then(response => {
        if (response.data[0].data != null) {
          commit("mtLoadLotesProducao", response.data[0].data);
        }
      })
      .catch(error => {
        commit("setSnack", { type: "error", msg: error });
      })
      .finally(() => {
        commit("mtChangeLoadingLotesProducao", false);
      });
  },
  actLoadAllLotesProducao: ({ commit }) => {
    commit("mtChangeLoadingLotesProducao", true);
    axios
      .get("lote-producao/")
      .then(response => {
        if (response.data[0].data != null) {
          commit("mtLoadLotesProducao", response.data[0].data);
        }
      })
      .catch(error => {
        commit("setSnack", { type: "error", msg: error });
      })
      .finally(() => {
        commit("mtChangeLoadingLotesProducao", false);
      });
  },
  actLoadTabelasConsumoRacao({ commit }) {
    commit("mtChangeLoadingTabelasConsumoRacao", true);
    axios
      .get("tabela-consumo-racao/")
      .then(response => {
        commit("mtLoadTabelasConsumoRacao", response.data[0].data);
      })
      .catch(error => {
        this.$store.commit("setSnack", { type: "error", msg: error });
      })
      .finally(() => {
        commit("mtChangeLoadingTabelasConsumoRacao", false);
      });
  },
  actLoadTabelaConfiguracao({ commit }) {
    commit("mtChangeLoadingTabelaConfiguracao", true);
    axios
      .get("tabela-configuracao/")
      .then(response => {
        let data = response.data[0].data != null ? response.data[0].data : [];
        commit("mtLoadTabelaConfiguracao", data);
      })
      .catch(error => {
        commit("setSnack", { type: "error", msg: error });
      })
      .finally(() => {
        commit("mtChangeLoadingTabelaConfiguracao", false);
      });
  },
  actLoadTabelasMetaMortalidade({ commit }) {
    commit("mtChangeLoadingTabelasMetaMortalidade", true);
    axios
      .get("tabela-meta-mortalidade/")
      .then(response => {
        let data = response.data[0].data != null ? response.data[0].data : [];
        commit("mtLoadTabelasMetaMortalidade", data);
      })
      .catch(error => {
        commit("setSnack", { type: "error", msg: error });
      })
      .finally(() => {
        commit("mtChangeLoadingTabelasMetaMortalidade", false);
      });
  },
  actLoadTiposFarmaco: ({ commit }) => {
    commit("mtChangeLoadingTiposFarmaco", true);
    axios
      .get("tipo-farmaco/")
      .then(response => {
        commit("mtLoadTiposFarmaco", response.data[0].data);
      })
      .catch(error => {
        commit("setSnack", { type: "error", msg: error });
      })
      .finally(() => {
        commit("mtChangeLoadingTiposFarmaco", false);
      });
  },
  actLoadFarmacos({ commit }) {
    commit("mtChangeLoadingFarmacos", true);
    axios
      .get("farmaco/")
      .then(response => {
        commit("mtLoadFarmacos", response.data[0].data);
      })
      .catch(error => {
        this.$store.commit("setSnack", { type: "error", msg: error });
      })
      .finally(() => {
        commit("mtChangeLoadingFarmacos", false);
      });
  },
  actLoadSinalClinico({ commit }) {
    commit("mtChangeLoadingSinalClinico", true);
    axios
      .get("sinal-clinico/")
      .then(response => {
        commit("mtLoadSinalClinico", response.data[0].data);
      })
      .catch(error => {
        this.$store.commit("setSnack", { type: "error", msg: error });
      })
      .finally(() => {
        commit("mtChangeLoadingSinalClinico", false);
      });
  },
  actLoadTiposCaminhao: ({ commit }) => {
    commit("mtChangeLoadingTiposCaminhao", true);
    axios
      .get("tipo-caminhao/")
      .then(response => {
        commit("mtLoadTiposCaminhao", response.data[0].data);
      })
      .catch(error => {
        commit("setSnack", { type: "error", msg: error });
      })
      .finally(() => {
        commit("mtChangeLoadingTiposCaminhao", false);
      });
  },
  actLoadTiposAdmFarmaco: ({ commit }) => {
    commit("mtChangeLoadingTiposAdmFarmaco", true);
    axios
      .get("adm-farmaco/lista-tipos/")
      .then(response => {
        commit("mtLoadTiposAdmFarmaco", response.data[0].data);
      })
      .catch(error => {
        commit("setSnack", { type: "error", msg: error });
      })
      .finally(() => {
        commit("mtChangeLoadingTiposAdmFarmaco", false);
      });
  }
};
